module.exports = __webpack_public_path__ + "static/media/Transporter.eab3d47e.png";